<template>
    <div class="appVersion">
        <div>
            <form :form="form" @submit.prevent="query"  class="logQuery">
                <SelectField labelWidth="30%" style="margin: 0.5rem 0.2rem;width:20%" label="模块" id="category" v-model="form.appModule" :options="moduleList"/>
                <SelectField labelWidth="30%" style="margin: 0.5rem 0.2rem;width:20%" label="类型" id="logType" v-model="form.logType" :options="logTypeList" />
                <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;width:20%" label="用户" type="text" id="userName" v-model="form.userName" placeholder="请输入用户"/>
                <RangePickerField
                    style="margin: 0.5rem 0.2rem;width:20%"
                    labelWidth="0"
                    v-model="form.date"
                    :placeholder="['开始日期', '结束日期']"
                    :disabled="false"
                    @change="handleDateChange"
                />
                <a-space style="margin: 0 0 0 0.5rem">
                    <ButtonField text="查询" @click="query" secondary />
                    <ButtonField text="重置" primary @click="reset"/>
                </a-space>
            </form>
        </div>

        <div style="padding-top: 2vh"></div>
        <Tablelist
            :showCheckbox="false"
            :list="list"
            :columns="tableColumns"
            @action="handleAction"
        >
            <template #template-logType="{ item }">
                <span v-if="item.logType === 0">操作日志</span>
                <span v-if="item.logType === 1">系统日志</span>
            </template>
        </Tablelist>

        <Modal v-if="visible" v-model="visible"
               :visible="visible"
               :title="'日志详情'"
               :showFooter="false"
               :overlayOpacity="0.5"
               @update:visible="visible = $event">
                <div class="form-group form-group1">
                    <label class="form-label" for="name">描述</label>
                    <div style="margin-left: 2rem;color: #fff;">{{ text.businessContent }}</div>
                </div>
                <div class="form-group form-group1">
                    <label class="form-label" for="name">详情</label>
                    <div style="margin-left: 2rem;color: #fff;">{{ text.content }}</div>
                </div>
        </Modal>



    </div>
</template>

<script>
import { fetchModuleList, fetchList } from "@/api/setting/log";
import Modal from '@/components/water-affairs-style/modal.vue';
export default {
  data() {
    return {
      moduleList: [],
      form: {},
      loading: false,
      current: 1,
      pageSize: 10,
        list:[
            {appModule:'-',logType:'0',operation:'-',userName:'-',logDate:'2025-08-01'}
        ],
      total: 0,
      logTypeList:[{ name: '操作日志', value: 0 },{ name: '系统日志', value: 1 }],
      visible: false,
      text: {},
      tableColumns: [
        {
            key: 'appModule',
            title: '模块',
            field: 'appModule',
            infotype: 'text'
        },
        {
            key: 'logType',
            title: '类型',
            field: 'logType',
            infotype: 'template',
        },
        {
            key: 'operation',
            title: '操作',
            field: 'operation',
            infotype: 'text',
            ellipsis: true
        },
        {
            key: 'userName',
            title: '用户',
            field: 'userName',
            ellipsis: true,
            infotype: 'text',
        },
        {
            key: 'logDate',
            title: '时间',
            field: 'logDate',
            ellipsis: true,
            infotype: 'text',
        },
        {
            key: 'actions',
            title: '操作',
            render: {
                view: true, edit: false, delete: false
            }
        }
      ]
    };
  },
    components: {
        Modal
    },
  mounted() {
    fetchModuleList().then((res) => {
      console.log("res", res);
      if (res && Array.isArray(res.app_module)) {
        this.moduleList = res.app_module;
      }
    });
    this.getList();
  },
  methods: {
      handleDateChange(dates, dateStrings) {
          console.log('日期范围变化：', dates, dateStrings);
      },
      handleAction(actionInfo){
          const { type, item } = actionInfo;
          switch(type) {
              case 'view':
                  this.openDetail(item);
                  break;
          }
      },
    getList() {
      this.loading = true;
      const { current, pageSize, form } = this;
      const { date } = form;

      let beginTs, endTs;

      if (Array.isArray(date) && date.length === 2) {
        beginTs = date[0].valueOf();
        endTs = date[1].valueOf();
      }
      fetchList({
        pageNum: current,
        pageSize,
        ...form,
        date: undefined,
        beginTs,
        endTs,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = typeof res.totalSize === "number" ? res.totalSize : 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.pageSize = 10;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.pageSize = 10;
      this.getList();
    },

    openDetail(text) {
      this.visible = true;
      this.text = text;
    },
  },
};
</script>
<style scoped>
.logQuery{
    display: flex;
    justify-content: start;
}
::v-deep .input-container{
    padding: 0;
}
.date-picker-field{
    display: flex;
    align-items: center;
    margin: 0 0.2rem;
    width: 20%;
}
::v-deep .ant-input{
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 10px;
    background: rgba(10, 20, 40, 0.6);
    color: #fff;
    font-size: 1rem;
    transition: all 0.3s ease;
    height: 50px;
}
::v-deep .ant-calendar-range-picker-separator{
    color: rgba(255,255,255,0.5);
}
.form-group{
    display: flex;
    justify-content: start;
}
.form-group1{
    padding-left: 5%;
    color: #adadad;
    margin: 2rem 0;
}
</style>